/*
  ROOMERS: автовыбор существующего варианта.

  Что делает: если покупатель переключил опцию (например, «Форма») и получилось
  сочетание, которого у товара нет, скрипт сам выбирает первое существующее
  значение в следующей опции (например, размер «30 см» вместо зачёркнутого «20 см»).

  Чего не делает: распроданные варианты не трогает. Вмешивается только тогда,
  когда варианта с таким сочетанием не существует вообще.

  Подключается одной строкой в конце snippets/js-variables.liquid. Чтобы отключить, удалите эту строку.
*/
(() => {
  const MAX_FIXES_IN_A_ROW = 3;
  const RETRIES = 12;
  const RETRY_DELAY_MS = 50;
  let fixesInARow = 0;

  const labelOf = (input) =>
    (input.id && document.querySelector(`label[for="${CSS.escape(input.id)}"]`)) || input.closest('label');

  const isUnavailable = (input) => {
    const label = labelOf(input);
    if (!label) return false;
    return label.classList.contains('is-disabled') || !!label.querySelector('.line-through');
  };

  const fixPicker = (formId) => {
    const picker = document.querySelector(`variant-picker[form-id="${CSS.escape(formId)}"]`);
    if (!picker) return false;

    for (const fieldset of picker.querySelectorAll('fieldset')) {
      const inputs = Array.from(fieldset.querySelectorAll('input[data-option-position]'));
      const checked = inputs.find((input) => input.checked);
      if (!checked || !isUnavailable(checked)) continue;

      const candidate = inputs.find((input) => input !== checked && !input.disabled && !isUnavailable(input));
      if (!candidate) return false;

      fixesInARow += 1;
      candidate.checked = true;
      candidate.dispatchEvent(new Event('change', { bubbles: true }));
      return true;
    }
    return false;
  };

  document.addEventListener('variant:change', (event) => {
    const variant = event.detail && event.detail.variant;

    if (variant && variant.id) {
      fixesInARow = 0;
      return;
    }
    if (fixesInARow >= MAX_FIXES_IN_A_ROW) {
      fixesInARow = 0;
      return;
    }

    const form = event.target;
    const formId = form && typeof form.getAttribute === 'function' ? form.getAttribute('id') : null;
    if (!formId) return;

    let attempt = 0;
    const tryFix = () => {
      if (fixPicker(formId)) return;
      attempt += 1;
      if (attempt < RETRIES) window.setTimeout(tryFix, RETRY_DELAY_MS);
    };
    window.setTimeout(tryFix, 0);
  });
})();
